module.exports = __webpack_public_path__ + "static/media/orange_nebula_UP.0ddb66b5.png";